import bridge from '../../../../assets/images/games/zdar-kids-game/bridge.webp';

export const step20talk = {
    id: 20,
    title: 'Vyšetřování',
    taskText: `
        <p>
            Tak máme nacvičeno, můžeme pokračovat v cestě. 
        </p>
    `,
    cipher: {
        text: 'Pokračujte dál k tomuto mostku v okolí',
        images: [bridge],
        label: 'Úkol',
    },
    continueButtonText: 'Jsme u mostu',
    points: false,
};
